import { ChangeEvent, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageListType } from 'react-images-uploading';
import { Form, ModalProps } from 'react-bootstrap';
import { ButtonImagePreview, ModalBox } from '../../../components';
import { useAppSelector } from '../../../hooks/redux';
import uniqId from 'uniqid';
import { ConfigData } from '../../../types/adminConfiguration';
import { uploadImage } from '../../../apis/tournament';

export const PaddleModal = (props: ModalProps) => {
    const { t } = useTranslation();
    const setConfigData = useAppSelector((state) => state.modals.data);
    const [paddle, setPaddle] = useState({
        model: '',
        img: '',
        value: '',
    });

    const prefix = 'modal-';
    const inputPrefix = 'input-';

    const handleSave = useCallback(() => {
        setConfigData((prevSate: ConfigData) => ({
            ...prevSate,
            paddles: [...prevSate.paddles, { id: uniqId(), ...paddle }],
        }));
        props.onHide && props.onHide();
    }, [paddle, props, setConfigData]);

    const handleInput = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setPaddle((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value.trim(),
        }));
    };

    const onChange = useCallback(
        (imageList: ImageListType) => {
            const formData = new FormData();
            formData.append('file', imageList[0]?.file || '');
            imageList[0].file &&
                uploadImage(formData, 'paddle')
                    .then((data) => {
                        setPaddle((prevState) => ({ ...prevState, img: data.url }));
                    })
                    .catch((e) => {
                        console.log(e);
                    });
        },
        []
    );

    return (
        <ModalBox
            {...props}
            handleSave={handleSave}
            isDisabled={!Boolean(paddle.value && paddle.model)}
        >
            <div className="d-flex flex-column">
                <p className="font-weight-normal mb-1">{t(prefix + 'paddleName') + ':'}</p>
                <Form.Control
                    autoComplete="off"
                    name="value"
                    maxLength={50}
                    placeholder={t(inputPrefix + 'placeholderName')}
                    onChange={handleInput}
                />
                <p className="font-weight-normal my-1">{t(prefix + 'model') + ':'}</p>
                <Form.Control
                    autoComplete="off"
                    name="model"
                    maxLength={50}
                    placeholder={t(inputPrefix + 'placeholderName')}
                    onChange={handleInput}
                />
                <ButtonImagePreview
                    title={t(prefix + 'image') + ':'}
                    onChange={onChange}
                    src={paddle.img}
                    alt="Paddle icon"
                />
            </div>
        </ModalBox>
    );
};
